// Dynamics CRM account ids
export const ACCOUNT_DYNAMIC_IDS = {
  HYUNDAI: '0cfce134-0dc9-e311-90d0-005056a20000',
  LEPPO: '729d8a07-fff5-e011-b432-005056a20000',
};
